import React from 'react';
import ImportToolbarNew from '@src/containers/TTS/ImportToolbarNew';
import { Divider } from '@mui/material';

const ImportData = ({
  useNewTtsUI,
  openSentences,
  handleChangeContent,
  onChangeInputLength,
  onChangeCharacterExceed,
  handleCloseSearchBoxAndMoreMenu,
  handleCloseSearchBox,
}) => (
  <div className="group group-import-data">
    <Divider orientation="vertical" flexItem className="divider" />
    <ImportToolbarNew
      useNewTtsUI={useNewTtsUI}
      openSentences={openSentences}
      onChangeContent={handleChangeContent}
      onChangeInputLength={onChangeInputLength}
      onChangeCharacterExceed={onChangeCharacterExceed}
      handleCloseSearchBoxAndMoreMenu={handleCloseSearchBoxAndMoreMenu}
      handleCloseSearchBox={handleCloseSearchBox}
      newUiImportData
    />
  </div>
);

export default ImportData;
